import { all, fork } from 'redux-saga/effects';

import auth from './auth';
import legalDocuments from './service-directory/legal-document';
import serviceDirectoryEntity from './service-directory/entity';
import serviceDirectoryCategory from './service-directory/category';
import serviceDirectoryArticle from './service-directory/article';
import serviceDirectorySocial from './service-directory/social';
import serviceDirectoryApiInfo from './service-directory/api-info';
import serviceDirectoryAppInfo from './service-directory/app-info';
import serviceDirectorySummary from './service-directory/summary';
import serviceDirectoryNotification from './service-directory/notification';
import serviceDirectoryServiceCatalogue from './service-directory/service-catalogue';
import serviceDirectoryServiceCategory from './service-directory/service-category';
import countryInformationRegions from './country-information/regions';
import countryInformationCountries from './country-information/countries';
import countryInformationCurrencies from './country-information/currencies';
import membershipUsers from './membership/users';
import featureItem from './service-directory/feature-item';
import rankItems from './service-directory/rank-items';

const rootSaga = function* root() {
  yield all([
    fork(auth),
    fork(legalDocuments),
    fork(serviceDirectoryEntity),
    fork(serviceDirectoryCategory),
    fork(serviceDirectoryArticle),
    fork(serviceDirectoryAppInfo),
    fork(serviceDirectoryApiInfo),
    fork(serviceDirectorySocial),
    fork(serviceDirectorySummary),
    fork(serviceDirectoryServiceCatalogue),
    fork(serviceDirectoryServiceCategory),
    fork(serviceDirectoryNotification),
    fork(countryInformationRegions),
    fork(countryInformationCountries),
    fork(countryInformationCurrencies),
    fork(membershipUsers),
    fork(featureItem),
    fork(rankItems),
  ]);
};

export default rootSaga;
